import React from 'react'
import classNames from 'classnames'
import { string, object, bool } from 'prop-types'
import ProductList from './productList.jsx'

class productTableTabs extends React.Component {
  getPriceKey (productType) {
    if (productType === 'HCP') return 'lowestDays8'
    if (productType === 'LO') return 'per_week'
    return 'per_week'
  }

  getPricePath (productType) {
    if (productType === 'HCP') return 'hotels'
    if (productType === 'LO') return 'lounges'
    return 'parking'
  }

  getCheapestPrice (productType, location) {
    try {
      const path = this.getPricePath(productType)
      const priceKey = this.getPriceKey(productType)
      let data = require('../../../../config/exports/buildTimeOnly/prices/' + path + '/' + location.code + '.json')
      const price = data.prices[priceKey]
      return price === '' ? false : price
    } catch (e) {
      return false
    }
  }

  renderParkingTabs () {
    const { id, location, pageData, dontShowHotelsInTable, terminal, setVar, domainSettings, settings } = this.props
    const cheapestPriceHCP = this.getCheapestPrice('HCP', location)
    const cheapestPriceCP = this.getCheapestPrice('CP', location)
    const hcpTitle = cheapestPriceHCP && (setVar && !setVar.hideTablePrices) ? 'Hotels with parking from £' + cheapestPriceHCP : 'Hotels with parking'
    const cpTitle = cheapestPriceCP && (setVar && !setVar.hideTablePrices) ? 'Parking from £' + cheapestPriceCP : 'Parking'
    let swapPageData = JSON.parse(JSON.stringify(pageData))
    swapPageData.productClass = 'HCP'
    const tabsWrapperClasses = classNames({
      'tabbable': !dontShowHotelsInTable
    })
    return (
      <div id={id} className={tabsWrapperClasses}>
        { !dontShowHotelsInTable &&
          <ul className='nav nav-tabs' style={{margin: '20px -20px'}}>
            <li className='active'><a href='#tableTabCP'><i className='hx-icon parking' /> <span>{ cpTitle }</span></a></li>
            <li><a href='#tableTabHCP'><i className='hx-icon hotelWithParking' /><span>{ hcpTitle }</span></a></li>
          </ul>
        }
        { !dontShowHotelsInTable &&
          <div className='tab-content'>
            <div className='tab-pane active' id='tableTabCP'>
              <ProductList id={id + '-table-parking'} domainSettings={domainSettings} pageData={pageData} location={location} terminal={terminal} settings={settings} setVar={setVar} />
            </div>
            <div className='tab-pane' id='tableTabHCP'>
              <ProductList id={id + '-table-hotels'} domainSettings={domainSettings} pageData={swapPageData} location={location} terminal={terminal} settings={settings} setVar={setVar} />
            </div>
          </div>
        }
        { dontShowHotelsInTable &&
          <ProductList id={id + '-table-parking'} domainSettings={domainSettings} pageData={pageData} location={location} terminal={terminal} settings={settings} setVar={setVar} />
        }
      </div>
    )
  }

  renderHotelTable () {
    const { id, location, pageData, terminal, domainSettings, settings } = this.props
    return (
      <div id={id}>
        <ProductList domainSettings={domainSettings} id={id + '-table-hotels'} pageData={pageData} location={location} terminal={terminal} settings={settings} />
      </div>
    )
  }

  renderLoungeTabs () {
    const { id, location, pageData, terminal, domainSettings, settings } = this.props
    return (
      <div id={id}>
        <ProductList domainSettings={domainSettings} id={id + '-table-lounges'} pageData={pageData} location={location} terminal={terminal} settings={settings} />
      </div>
    )
  }

  render () {
    const { pageData } = this.props
    const parking = (pageData.productClass.toUpperCase() === 'CP')
    const lounges = (pageData.productClass.toUpperCase() === 'LO')
    if (parking) {
      return this.renderParkingTabs()
    } else if (lounges) {
      return this.renderLoungeTabs()
    }
    return this.renderHotelTable()
  }
}

productTableTabs.propTypes = {
  id: string.isRequired,
  pageData: object,
  location: object,
  terminal: string,
  settings: object,
  dontShowHotelsInTable: bool,
  setVar: object,
  domainSettings: object
}

export default productTableTabs



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/productListTabs.jsx